module.exports = __webpack_public_path__ + "static/media/doc_kyc.8f9635b3.svg";